import { render } from "./TargetEventAdd.vue?vue&type=template&id=6ae08c39"
import script from "./TargetEventAdd.vue?vue&type=script&lang=js"
export * from "./TargetEventAdd.vue?vue&type=script&lang=js"

import "./TargetEventAdd.vue?vue&type=style&index=0&id=6ae08c39&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__